import React from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: React.ReactNode
};

// render a React component at the end of the body of the html document iso the place where it is created
// see https://css-tricks.com/using-react-portals-to-render-children-outside-the-dom-hierarchy/

class AppendToBody extends React.Component<Props> {
  rootDiv: HTMLDivElement;

  constructor (props: Props) {
    super(props);
    this.rootDiv = document.createElement('div');
    if (document.body != null) {
      document.body.appendChild(this.rootDiv);
    }
  }

  override componentWillUnmount (): void {
    if (document.body != null) {
      document.body.removeChild(this.rootDiv);
    }
  }

  override render (): React.ReactNode {
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.rootDiv);
  }
}

export default AppendToBody;
